<template>
  <b-card
    class="destination-map text-center"
    title-footer="footer"
    img-top
    :img-src="googleStaticMapUrl"
  >
    <h3>{{ heading }}</h3>
    <div class="mb-2">
      <slot name="address" />
    </div>
    <slot name="content" />
    <div slot="footer" class="footer">
      {{ message }}
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    isDelivery: {
      type: Boolean,
    },
    googleStaticMapUrl: {
      type: String,
    },
  },
  computed: {
    heading() {
      return this.isDelivery ? 'DELIVERING TO' : 'PICKUP RESTAURANT'
    },
    message() {
      return this.isDelivery
        ? 'We are working on finding your driver.'
        : "Go straight to the Order Pickup and tell a crew member you're picking up a catering order."
    },
  },
}
</script>

<style lang="scss" scoped>
.destination-map {
  .footer {
    line-height: 1.3;
  }
  .card-footer {
    background-color: white;
  }
}
@include media-breakpoint-up(md) {
  .destination-map {
    .footer {
      max-width: 300px;
      margin: 0 auto;
    }
  }
}
</style>
